import { GET_LANGUAGE_URL } from "../../api/routes";
import * as actionTypes from "../actions/types/configurationActionTypes";
import { conventionFetch } from "../../utils/fetchWrapper";

export function getLanguage() {
  return () => {
    return conventionFetch(GET_LANGUAGE_URL(), { method: "GET" })
      .withActionType(actionTypes.GET_LANGUAGE)
      .prepare()
      .start();
  };
}



// WEBPACK FOOTER //
// ./src/redux/thunks/configurationThunks.js